import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { getAuth } from "../../utils";
import { type Wishlist, wishlist } from "../schemas/wishlist";

export const deleteAnonymousWishlistItemProps = z
  .object({
    wishlistToken: z.string(),
    wishlistId: z.string(),
    itemId: z.number(),
  })
  .extend(requestConfig.shape);

export type DeleteAnonymousWishlistItemProps = z.infer<
  typeof deleteAnonymousWishlistItemProps
>;

export const deleteAnonymousWishlistItem = async (
  args: DeleteAnonymousWishlistItemProps,
): Promise<Wishlist> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    auth: Authorization = getAuth(),
    wishlistToken,
    wishlistId,
    itemId,
  } = parseServiceInput(deleteAnonymousWishlistItemProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization,
  });
  if (wishlistToken) {
    headers.append("x-wishlist-token", `Bearer ${wishlistToken}`);
  }

  const response = await fetch(
    `${endpoint}/v1/wishlist/anonymous/${wishlistId}/${itemId}`,
    {
      method: "DELETE",
      headers,
    },
  );

  return parseServiceOutput(response, wishlist, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
